import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetWorkoutByUserId } from "../../../fakebackend_helper";

export const GetWorkoutByUserIdServices = createAsyncThunk(
    'workout/fetchWorkout',
    async (userId, { rejectWithValue }) => {
        try {
            const response = await GetWorkoutByUserId(userId);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Erreur lors du chargement des objectifs');
        }
    }
)
